module.exports = __webpack_public_path__ + "static/media/logo-Servientrega.b69f2574.png";